import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import { IoIosArrowDown } from "react-icons/io";
import { FaCog, FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";

function Customer({ currency }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: "SN",
      accessorKey: "SN",
      cell: (sn) => sn.row.index + 1,
    },
    {
      header: "Customer Name",
      accessorKey: "name",
    },
    {
      header: "Phone",
      accessorKey: "phone",
    },
    {
      header: "Customer Vat No",
      accessorKey: "customer_vat",
    },
    {
      header: "Email",
      accessorKey: "email",
    },
    {
      header: "DOB",
      accessorKey: "date_of_birth",
    },
    {
      header: "DOA",
      accessorKey: "created_at",
      cell: (doa) => doa.getValue().slice(0, 10),
    },
    {
      header: "Address",
      accessorKey: "address",
      cell: (add) => add.row.original.addresses[0]?.address_line_1,
    },
    // {
    //   header: "Added By",
    //   accessorKey: "AddedBy",
    // },
    {
      header: "Actions",
      cell: (row) => (
        <ActionDropdown
          id={row.row.original.id}
          user={user}
          refetchData={fetchCustomers}
          setModalOpen={setModalOpen}
          setSelectedCustomer={setSelectedCustomer}
        />
      ),
    },
  ];
  const [data, setData] = useState([]);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const buttonData = [
    {
      buttonText: "Add Customer",
      path: "addCustomerForm",
    },
    {
      buttonText: "Upload Customer",
      path: "uploadCustomer",
    },
  ];

  const fetchCustomers = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/customer`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [user?.token]);

  const fetchSubscriptions = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/subscription`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setSubscriptionData(res.data?.data);
      });
  }, [user?.token]);

  useEffect(() => {
    fetchCustomers();
    fetchSubscriptions();
  }, [fetchCustomers, fetchSubscriptions]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Customers"}
        buttonData={buttonData}
      />
      {modalOpen && (
        <SubscriptionModal
          data={subscriptionData}
          setModalOpen={setModalOpen}
          selectedCustomer={selectedCustomer}
          user={user}
          currency={currency}
        />
      )}
    </main>
  );
}

function ActionDropdown({
  id,
  user,
  refetchData,
  setModalOpen,
  setSelectedCustomer,
}) {
  const [showDropdown, setShowDropDown] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);

  const handleDelete = () => {
    axios
      .delete(`${apiKey}/api/rms/admin/categories/schedule/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.data || "Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        refetchData();
        setShowDelModal(false);
        setShowDropDown(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  return (
    <>
      <div className="relative">
        <button
          className="text-blueGray-500 px-3 flex items-center justify-between gap-1 border rounded-full"
          onClick={() => setShowDropDown(!showDropdown)}
        >
          <FaCog className="text-d-bg-text" />
          <IoIosArrowDown className="text-d-bg-text" />
        </button>
        <div
          className={
            (showDropdown ? "block " : "hidden ") +
            "absolute top-4 left-0 -translate-x-[75%] bg-white text-base z-10 float-left py-2 list-none text-left rounded shadow-lg min-w-40"
          }
        >
          <button
            onClick={() => {
              setSelectedCustomer(id);
              setModalOpen(true);
            }}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaStar />
            <p> Add Subscription </p>
          </button>
          <Link
            to={`addCustomerForm/${id}`}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaEdit />
            <p> Edit </p>
          </Link>
          {/* <button
            onClick={() => setShowDelModal(true)}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaTrashAlt />
            <p> Delete </p>
          </button> */}
        </div>
      </div>

      {showDelModal && (
        <div
          className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10"
          onClick={() => setShowDelModal(false)}
        >
          <div
            className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <h1 className="text-d-bg-text font-semibold text-xl text-center">
                Alert!
              </h1>
              <p className="text-center text-gray-700">Are you sure?</p>
            </div>
            <div className="flex justify-center gap-4">
              <button
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                onClick={() => setShowDelModal(false)}
              >
                No
              </button>
              <button
                onClick={handleDelete}
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function SubscriptionModal({ data, setModalOpen, selectedCustomer, user, currency }) {
  const subscribe = (id) => {
    axios
      .post(
        `${apiKey}/api/rms/admin/subscription/subscribe`,
        {
          customer_id: selectedCustomer,
          subscription_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.data || "Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setModalOpen(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
  return (
    <div className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10">
      <div className="p-4 rounded-lg bg-white max-w-xl w-full space-y-4 relative">
        <button
          onClick={() => setModalOpen(false)}
          className="absolute top-4 right-4"
        >
          <FaXmark />
        </button>
        <h1 className="text-d-bg-text font-semibold text-lg">
          Add Subscription by Customer
        </h1>
        {data?.map((item, index) => {
          return (
            <div key={index}>
              <h2 className="text-d-bg-text ">{item.heading}</h2>
              <div className="text-sm text-gray-800 mt-2">
                <p>For {item.expire_days} Days</p>
                <p>Price - {item.amount} {currency.value || "S.R"}</p>
                <p>Delivery Charges - {item.delivery_charge} {currency.value || "S.R"}</p>
                <p>Discount - {item.cat_discount}%</p>
                <p>Total Meal Quantity - {item.item_qty}</p>
                <p>On below categories:</p>
                <div>
                  {item.subscription_categories.map((category, idx) => (
                    <p className="ml-4" key={idx}>
                      {category?.categories?.category_name}
                    </p>
                  ))}
                </div>
              </div>
              <button
                onClick={() => subscribe(item.id)}
                className="bg-yellow-500 p-2 rounded-lg text-white text-center text-sm mt-4"
              >
                Subscribe Now
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Customer;
